import { render, staticRenderFns } from "./CalonAnggota.vue?vue&type=template&id=d4d3a8d4&"
import script from "./CalonAnggota.vue?vue&type=script&lang=js&"
export * from "./CalonAnggota.vue?vue&type=script&lang=js&"
import style0 from "./CalonAnggota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports